import { Component, OnInit, HostListener } from '@angular/core';
import { LayoutService } from '../services';

@Component({
  selector: 'lib-layout',
  templateUrl: './layout.component.html',
  styles: [
    `
      .page-wrapper {
        display: flex;
        flex-direction: column;
      }
      .container-fluid {
        display: flex;
        flex-grow: 1;
        padding-top: 10px;
      }
    `,
  ],
})
export class LayoutComponent implements OnInit {
  constructor(public layoutSvc: LayoutService) {}

  @HostListener('window:resize', ['$event'])
  onResize(evt: any): void {
    this.layoutSvc.handleSidebar();
  }

  expandLogo(): void {
    this.layoutSvc.toggleExpandLogo();
  }

  ngOnInit(): void {
    this.layoutSvc.handleSidebar();
  }

  toggleCollapsed() {
    this.layoutSvc.toggleCollapsed();
  }

  toggleMobileMenu() {
    this.layoutSvc.toggleMobileMenu();
  }

  toggleSidebarType(): void {
    this.layoutSvc.toggleSidebarType();
  }
}
